<script>
import ButtonNext from 'next/button/Button.vue';
import Spinner from 'next/spinner/Spinner.vue';

export default {
  components: {
    ButtonNext,
    Spinner,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    empty: {
      type: Boolean,
      default: false,
    },
    query: {
      type: String,
      default: '',
    },
    isFetching: {
      type: Boolean,
      default: true,
    },
    page: {
      type: Number,
      default: 1,
    },
    totalPages: {
      type: Number,
      default: 1,
    },
  },
  emits: ['previousPage', 'nextPage'],
  computed: {
    titleCase() {
      return this.title.toLowerCase();
    },
    isFirstPage() {
      return this.page === 1;
    },
    isLastPage() {
      return this.page === this.totalPages;
    },
  },
  methods: {
    nextPage() {
      this.$emit('nextPage');
    },
    previousPage() {
      this.$emit('previousPage');
    },
  },
};
</script>

<template>
  <section class="result-section">
    <div class="flex flex-col gap-2">
      <slot />
    </div>

    <div
      v-if="empty && !isFetching"
      class="flex justify-center items-center gap-2"
    >
      <fluent-icon icon="info" size="16px" class="icon" />
      <p class="empty-state__text">
        {{ $t('SEARCH.EMPTY_STATE', { item: titleCase, query }) }}
      </p>
    </div>

    <div
      v-else-if="isFetching"
      class="flex items-center justify-center py-10 text-n-slate-11"
    >
      <Spinner />
    </div>

    <div v-else class="flex items-center justify-center m-8">
      <ButtonNext
        :disabled="isFetching || isFirstPage"
        icon="i-lucide-chevron-left"
        variant="faded"
        size="sm"
        color="slate"
        @click="previousPage"
      />
      <p class="text-xs text-n-slate-11 dark:text-slate-300 mx-4 m-0">
        {{ page }} / {{ totalPages }}
      </p>
      <ButtonNext
        :disabled="isFetching || isLastPage"
        icon="i-lucide-chevron-right"
        variant="faded"
        size="sm"
        color="slate"
        @click="nextPage"
      />
    </div>
  </section>
</template>

<style scoped lang="scss">
.result-section {
  @apply my-6 mx-0;
}
.search-list {
  @apply m-0 py-4 px-0 list-none;
}
.header {
  @apply sticky top-0 py-2 z-50 bg-white dark:bg-slate-800 mb-0.5;
}

.empty {
  @apply flex items-center justify-center py-6 px-4 my-2 bg-slate-25 dark:bg-slate-700 rounded-md;
  .icon {
    @apply text-slate-500 dark:text-slate-300;
  }
  .empty-state__text {
    @apply text-slate-500 dark:text-slate-300 text-center my-0 mx-2;
  }
}
</style>
